import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useAllUsersDashboard } from "../../../../context/SuperAdmin/DashboardContexts/AllUsers";

const PickSuborg = () => {
  const { control } = useForm();
  const { isLoadingSuborgs, selectedSuborg, suborgs, changeSuborg } =
    useAllUsersDashboard();
  return (
    <Grid
      item
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
      }}
    >
      {isLoadingSuborgs ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Controller
          name="Organización"
          control={control}
          defaultValue={selectedSuborg}
          render={({ field }) => (
            <FormControl sx={{ width: "400px" }}>
              <InputLabel>Selecciona una suborganización</InputLabel>
              <Select
                {...field}
                onChange={(event) => {
                  field.onChange(event); // Mantiene la integración con react-hook-form
                  changeSuborg(event); // Llama a la función externa para actualizar el estado global
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      overflowY: "auto",
                    },
                  },
                }}
                label="Selecciona una suborganización"
              >
                {suborgs.map((suborg) => (
                  <MenuItem
                    key={suborg.id_suborganizacion}
                    value={suborg.id_suborganizacion}
                  >
                    {suborg.suborganizacion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      )}
    </Grid>
  );
};

export default PickSuborg;
